// extracted by mini-css-extract-plugin
export default {"screenReaderOnly":"styles_screenReaderOnly__VpIfP"};